// src/pages/ContactPage.tsx
import React from 'react';
import { Container, Typography } from '@mui/material';

const ContactPage: React.FC = () => (
    <Container maxWidth="md">
        <Typography variant="h4" component="h1" gutterBottom>Contact Us</Typography>
        <Typography variant="body1">
            If you have any questions, feel free to reach out to us at support@laiatools.com.
        </Typography>
    </Container>
);

export default ContactPage;